import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { toast } from 'react-toastify';
import Pagination from '../Common/Pagination';
import { Context } from '../../context/UserContext';
import ReactInputMask from 'react-input-mask';
import ReactSelect from 'react-select';

const Index = () => {

    const context = useContext(Context);
    const { readData } = useEntityCrud('User/GetAllUsers');
    const { readData: getRoles } = useEntityCrud('Role/GetAllRole');
    const { addData: updateData } = useEntityCrud('User/ChangeStatus');
    const [rows, setRows] = useState([]);
    const [roles, setRoles] = useState([]);
    const [pages, setPages] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);

    const [branchId, setBranchId] = useState(0);
    const [branchs, setBranchs] = useState([]);
    const { readData: getBranchs } = useEntityCrud('Branch/GetAllBranchs');

    const [businessId, setBusinessId] = useState(0);
    const [businesses, setBusinesses] = useState([]);
    const { readData: getBusinesses } = useEntityCrud('Business/GetAllBusinesses');
    
    const [guildId, setGuildId] = useState(0);
    const [guildes, setGuilds] = useState([]);
    const { readData: getGuilds } = useEntityCrud('Guild/GetAllGuilds');

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [username, setUsername] = useState('');
    const [nationalCode, setNationalCode] = useState('');
    const [roleId, setRoleId] = useState('');
    const [mobile, setMobile] = useState('');
    const [searched, setSearched] = useState(false);
    const [lastPage,setLastPage] = useState(0);
    const [count,setCount] = useState(0);


    const getData = (searchData) => {

        const postedData = {
            offset: 0,
            limit: 10,
            ...searchData
        };
        readData(postedData).then(res => {

            if (res.data.status) {
                calcPages(res);
                setRows(res.data.result);
            } else {
                setRows([]);
                setPages([]);
            }
        })
    }

    const downloadExcel = () => {
        document.getElementById('download-excel').classList.add('btn-loading');
        const postedData = {
            excelOutput: true
        };
        readData(postedData).then(({ data }) => {
            if (data.status) {
                window.open(data.excelPath);
            }
        }).finally(() => {
            document.getElementById('download-excel').classList.remove('btn-loading');
        });
    };

    useEffect(() => {
        getData();
        getRoles().then(({data}) => {
            if(data.status)
                setRoles(data.result);
        })
        getBranchs().then(({ data }) => {
            let branchs = [];
            if (data.status)
                data.result.map(item => {
                    if (item.isActive)
                        branchs.push({
                            label: item.title,
                            value: item.id
                        });
                })
            setBranchs(branchs);
        })
        getBusinesses().then(({ data }) => {
            let business = [];
            if (data.status)
                data.result.map(item => {
                    if (item.isActive)
                        business.push({
                            label: item.title,
                            value: item.id
                        });
                })
            setBusinesses(business);
        })
        getGuilds().then(({ data }) => {
            let guild = [];
            if (data.status)
                data.result.map(item => {
                    guild.push({
                        label: item.title,
                        value: item.id
                    });
                })
            setGuilds(guild);
        })
    }, [])

    const calcPages = res => {
        let calcPages = res.data.count / 10;
        setCount(res.data.count)

        calcPages = calcPages > 1 ? Math.ceil(calcPages) : 1
        let pagesArray = [];
        for (let i = 1; i <= calcPages; i++)
            pagesArray.push(i);
        setLastPage(pagesArray.length)
        setPages(pagesArray);
        setCurrentPage(1);
    }

    const changePage = (e, page) => {
        e.preventDefault();
        setCurrentPage(page);

        const postedData = {
            limit: 10,
            offset: page - 1
        };

        if (mobile)
            postedData.mobile = mobile;
        if (nationalCode)
            postedData.nationalCode = nationalCode;
        if (firstName)
            postedData.firstName = firstName;
        if (lastName)
            postedData.lastName = lastName;
        if (username)
            postedData.username = username;
        if (roleId)
            postedData.roleId = parseInt(roleId);
        if (businessId)
            postedData.busId = businessId;
        if (guildId)
            postedData.gId = guildId;
        readData(postedData).then(res => {
            setRows(res.data.result);
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }

    const prevPage = e => {
        e.preventDefault();
        setCurrentPage(currentPage - 1);

        const postedData = {
            limit: 10,
            offset: currentPage - 2
        };

        if (mobile)
            postedData.mobile = mobile;
        if (nationalCode)
            postedData.nationalCode = nationalCode;
        if (firstName)
            postedData.firstName = firstName;
        if (lastName)
            postedData.lastName = lastName;
        if (username)
            postedData.username = username;
        if (roleId)
            postedData.roleId = parseInt(roleId);
        if (businessId)
            postedData.busId = businessId;
        if (guildId)
            postedData.gId = guildId;

        readData(postedData).then(res => {
            setRows(res.data.result);
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }

    const nextPage = e => {
        e.preventDefault();
        setCurrentPage(currentPage + 1);

        const postedData = {
            limit: 10,
            offset: currentPage
        };

        if (mobile)
            postedData.mobile = mobile;
        if (nationalCode)
            postedData.nationalCode = nationalCode;
        if (firstName)
            postedData.firstName = firstName;
        if (lastName)
            postedData.lastName = lastName;
        if (username)
            postedData.username = username;
        if (roleId)
            postedData.roleId = parseInt(roleId);
        if (businessId)
            postedData.busId = businessId;
        if (guildId)
            postedData.gId = guildId;

        readData(postedData).then(res => {
            setRows(res.data.result);
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }

    const deActiveRow = id => {
        const postedData = {
            id,
            status: false
        };
        updateData(postedData).then(({ data }) => {
            if (data.status) {
                toast.success('وضعیت کاربر مورد نظر با موفقیت به روزرسانی شد');
                const oldRows = [...rows];
                const index = oldRows.findIndex(row => row.id == id);
                oldRows[index].isActive = !oldRows[index].isActive;
                setRows([...oldRows]);
            } else
                data.errors.map(error => toast.error(error.message));
        });
    }

    const disableCardHandler = id => {
        debugger
        const postedData = {
            id,
            disableCard: true
        };
        updateData(postedData).then(({ data }) => {
            debugger
            if (data.status) {
                toast.success('وضعیت کاربر مورد نظر با موفقیت به روزرسانی شد');
                getData();
            } else
                data?.errors?.map(error => toast.error(error.message));
        });
    }

    const activeRow = id => {
        const postedData = {
            id,
            status: true
        };
        updateData(postedData).then(({ data }) => {
            if (data.status) {
                toast.success('وضعیت کاربر مورد نظر با موفقیت به روزرسانی شد');
                const oldRows = [...rows];
                const index = oldRows.findIndex(row => row.id == id);
                oldRows[index].isActive = !oldRows[index].isActive;
                setRows([...oldRows]);
            } else
                data.errors.map(error => toast.error(error.message));
        });
    }

    const searchData = e => {

        e.preventDefault();
        const postedData = {};
        if (mobile)
            postedData.mobile = mobile.toString().replace('-','');
        if (nationalCode)
            postedData.nationalCode = nationalCode;
        if (firstName)
            postedData.firstName = firstName;
        if (lastName)
            postedData.lastName = lastName;
        if (username)
            postedData.username = username;
        if (roleId)
            postedData.roleId = parseInt(roleId);
        if (branchId)
            postedData.branchId = branchId;
        if (businessId)
            postedData.busId = businessId;
        if (guildId)
            postedData.gId = guildId;
        getData(postedData);
        setSearched(true);
    }

    const clearSearch = e => {
        e.preventDefault();
        setFirstName('');
        setLastName('');
        setMobile('');
        setNationalCode('');
        setUsername('');
        setRoleId('');
        setBranchId('');
        setBusinessId('');
        setSearched(false);
        getData({});
    }


    return (
        <div className="card">
            <div className="card-header">
                <div className="card-title">کاربران</div>
            </div>
            <div className="card-body">
                {context.checkHasPermission('create') ? <Link className="btn btn-primary" to="create">ایجاد کاربر</Link> : ''}
                <button
                    className="btn btn-success ms-2"
                    id="download-excel"
                    aria-expanded="false"
                    onClick={downloadExcel}>
                    دریافت خروجی اکسل
                </button>
                <button className="btn btn-dark mx-2 accordion-toggle collapsed" data-bs-toggle="collapse" data-bs-parent="#accordion" href="#collapseFour" aria-expanded="false">جستجو</button>

                <div className="panel-group1" id="accordion1">
                    <div id="collapseFour" className="panel-collapse collapse position-relative" role="tabpanel" aria-expanded="false">
                        <form onSubmit={e => searchData(e)} className="row mt-4">
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>نام</label>
                                    <input className="form-control" value={firstName} onChange={e => setFirstName(e.target.value)} />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>نام خانوادگی</label>
                                    <input className="form-control" value={lastName} onChange={e => setLastName(e.target.value)} />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>شماره همراه</label>
                                    <ReactInputMask className="form-control ltr-input" mask="0999-9999999" value={mobile} onChange={e => setMobile(e.target.value)} />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>کد ملی</label>
                                    <input type="tel" className="form-control ltr-input" value={nationalCode} onChange={e => setNationalCode(e.target.value)} maxLength={10} />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>نام کاربری</label>
                                    <input type="tel" className="form-control ltr-input" value={username} onChange={e => setUsername(e.target.value)} maxLength={10} />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>نقش کاربر</label>
                                    <select className="form-control" onChange={e => setRoleId(e.target.value)}>
                                        <option>انتخاب کنید</option>
                                        {roles.map(role => <option value={role.id}>{role.title}</option>)}
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>شرکت    </label>
                                    {branchId ? <i className="fe fe-x clear-select-btn" onClick={e => setBranchId('')}></i> : ''}
                                    <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="  همه موارد " options={branchs} value={branchs.filter(b => b.value == branchId)} onChange={e => setBranchId(e.value)} />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>کسب و کار</label>
                                    {businessId ? <i className="fe fe-x clear-select-btn" onClick={e => setBusinessId('')}></i> : ''}
                                    <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="  همه موارد " options={businesses} value={businesses.filter(b => b.value == businessId)} onChange={e => setBusinessId(e.value)} />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>صنف</label>
                                    {guildId ? <i className="fe fe-x clear-select-btn" onClick={e => setGuildId('')}></i> : ''}
                                    <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="  همه موارد " options={guildes} value={guildes.filter(b => b.value == guildId)} onChange={e => setGuildId(e.value)} />
                                </div>
                            </div>

                            <div className="col-md-4" style={{marginTop: 29}}>
                                <button className="btn btn-success me-2">جستجو</button>
                                {searched ? <button className="btn btn-danger" onClick={clearSearch} type="button">بازنشانی</button> : ''}
                            </div>
                        </form>
                    </div>
                </div>

                <hr />
                {rows.length ?
                    <div className="table-responsive">
                        <table className="table table-bordered table-hover border text-nowrap text-md-nowrap">
                            <thead>
                                <tr>
                                    <th>ردیف</th>
                                    <th>نام</th>
                                    <th>نام خانوادگی</th>
                                    <th>کد ملی</th>
                                    <th>نام کاربری</th>
                                    <th>شماره همراه</th>
                                    <th>نقش</th>
                                    <th>وضعیت</th>
                                    <th>عملیات</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((item, index) => (
                                    <tr key={index}>
                                        <td>{(index + 1) + (currentPage > 1 ? (currentPage - 1) * 10 : '')}</td>
                                        <td>{item.firstName}</td>
                                        <td>{item.lastName}</td>
                                        <td>{item.nationalCode}</td>
                                        <td>{item.username}</td>
                                        <td>{item.mobile}</td>
                                        <td>{item.roleTitle || '-'}</td>
                                        <td>{item.isActive ? <i className="fe fe-check text-success"></i> : <i className="fe fe-x text-danger"></i>}</td>
                                        <td className="btn-list">
                                            {context.checkHasPermission('update') ? <Link to={'update/' + item.id} className="btn btn-icon mb-0 btn-primary" title="ویرایش"><i className="fe fe-edit-2"></i></Link> : ''}
                                            {context.checkHasPermission('delete') ?
                                                (item.isActive ? <button onClick={e => deActiveRow(item.id)} className="btn btn-icon mb-0 btn-danger" title="غیرفعال سازی"><i className="fe fe-x"></i></button> : <button onClick={e => activeRow(item.id)} className="btn btn-icon mb-0 btn-success" title="فعال سازی"><i className="fe fe-check"></i></button>) : ''}
                                            {item.roleId == 83 && <button
                                                onClick={e => disableCardHandler(item.id)}
                                                title="غیرفعال سازی کارت"
                                                className="btn btn-icon mb-0 btn-warning">
                                                <i className="fa fa-credit-card"></i>
                                            </button>}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <p>تعداد کل ردیف ها : {count || 0}</p>

                        <Pagination changePage={changePage} currentPage={currentPage} pages={pages} prevPageClick={prevPage} nextPageClick={nextPage} lastPage={lastPage} />
                    </div>
                    :
                    <div className="alert alert-info"><p>داده ای یافت نشد</p></div>}
            </div>
        </div>
    );
}

export default Index;